import { render, staticRenderFns } from "./_filter_list_for_deleted.vue?vue&type=template&id=120ca40f&scoped=true&"
import script from "./_filter_list_for_deleted.vue?vue&type=script&lang=js&"
export * from "./_filter_list_for_deleted.vue?vue&type=script&lang=js&"
import style0 from "./_filter_list_for_deleted.vue?vue&type=style&index=0&id=120ca40f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ca40f",
  null
  
)

export default component.exports